"use client";

import Image from "next/image";

function Icon({
  name,
  className = "",
  fill = false,
}: {
  name: string;
  className?: string;
  fill?: boolean;
}) {
  return (
    <span
      className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}
    >
      {name}
    </span>
  );
}

// A verified Saudi-man portrait (traditional thobe + shemagh) from Unsplash.
const HERO_IMG = "/properity.jpg";

const STATS = [
  { val: "2,000+", ar: "عميل", en: "Guests" },
  { val: "24h", ar: "متوسط الرد", en: "Avg. response" },
  { val: "%98", ar: "رضا الملّاك", en: "Owner satisfaction" },
];

export default function ListingHero({ isAr }: { isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);

  const scrollToForm = () => {
    document
      .getElementById("listing-form")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="najdi relative bg-background pt-14 pb-16 md:pt-20 md:pb-24 overflow-hidden">
      <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Content */}
        <div className="space-y-8 z-10" dir={isAr ? "rtl" : "ltr"}>
          <div>
            <span className="inline-block bg-clay-100 text-clay-600 px-4 py-1 rounded-full text-sm font-medium mb-4">
              {t("انضم إلى شركاء منازل الدرعية", "Join Diriyah Homes partners")}
            </span>
            <h1 className="font-display text-4xl md:text-5xl lg:text-[56px] leading-tight font-extrabold text-clay-600">
              {t("أضف", "List")}{" "}
              <span className="text-ink-900">
                {t("وحدتك", "your property")}
              </span>{" "}
              {t("وابدأ بالربح", "and start earning")}
            </h1>
            <p className="text-lg text-ink-500 max-w-lg mt-4 leading-relaxed">
              {t(
                "سجّل وحدتك مع منازل الدرعية واستفد من شبكة آلاف العملاء. أرسل طلبك الآن وسيتواصل معك فريقنا خلال ٢٤ ساعة.",
                "List your property with Diriyah Homes and reach thousands of guests. Submit now and our team will contact you within 24 hours.",
              )}
            </p>
          </div>

          <button
            onClick={scrollToForm}
            className="bg-clay-600 text-white px-10 py-4 rounded-xl font-bold hover:bg-clay-700 transition-all inline-flex items-center gap-2"
          >
            {t("ابدأ الآن", "Get started")}
            <Icon name="arrow_downward" />
          </button>

          <div className="pt-6 border-t border-clay-100 flex flex-wrap gap-8">
            {STATS.map((s) => (
              <div key={s.val} className="flex flex-col">
                <span className="font-display text-3xl font-bold text-clay-600">
                  {s.val}
                </span>
                <span className="mt-1 text-xs text-ink-500">
                  {t(s.ar, s.en)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Image */}
        <div className="relative group">
          <div className="aspect-4/5 rounded-3xl overflow-hidden shadow-2xl relative bg-clay-100">
            <Image
              src={HERO_IMG}
              alt={t("مالك وحدة سعودي", "Saudi property owner")}
              fill
              priority
              unoptimized
              className=" transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-linear-to-t from-clay-600/30 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
